import { useMobileAppContext } from "@/contexts/mobileAppContext";

export const useIsMoxieMobile = () => {
  const { isMoxieMobile } = useMobileAppContext();

  return { isMoxieMobile };
};
